/* eslint-disable no-console */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Icon from '@mdi/react';
import { mdiCheck } from '@mdi/js';
import React from 'react';
import { useIntl } from 'react-intl';
import useSetWizardStep from '../../hooks/useSetWizardStep';
import useWizardStep from '../../hooks/useWizardStep';
import { stepsPairs } from '../Wizard';
// import getPromotionDaysAvailability from '../../api/getPromotionDaysAvailability';
import classes from './classes.module.css';

const stepMax = (window as any).maxStep ?? 5;

const Stepper: React.FC = () => {
  const intl = useIntl();
  const currentStep = useWizardStep();
  const handleSetStep = useSetWizardStep();


  // const displayButton = getPromotionDaysAvailability({ location: window.location });
  // console.log(displayButton);
  // console.log(window.location.pathname);

  return (
    <>
      {currentStep < stepMax ? (
        <div className={classes.stepperWrapper}>
          {stepsPairs
            .filter((_, index) => index < stepMax)
            .map(([name, step]) => (
              <React.Fragment key={step.toString()}>
                {currentStep - 1 >= step ? (
                  <div
                    className={`${classes.stepperItem} ${classes.completed}`}
                    role='button'
                    aria-pressed='false'
                    tabIndex={0}
                    onClick={() => {handleSetStep(step)}}
                  >
                    <div className={`${classes.stepCounter} ${classes.active}`}>
                        <Icon
                          path={mdiCheck}
                          style={{ stroke: '#ffffff', strokeWidth: '0' }}
                          size={'32px'}
                        />
                    </div>
                    <div className={classes.stepName}>{intl.formatMessage({ id: `step.${name}` })}</div>
                  </div>
                ) : currentStep === step ? (
                  <div className={`${classes.stepperItem} ${classes.current}`}>
                      <div className={classes.stepCounter}>{step}</div>
                      <div className={classes.stepName}>{intl.formatMessage({ id: `step.${name}` })}</div>
                  </div>
                ) : (
                  <div className={classes.stepperItem}>
                    <div className={classes.stepCounter}>{step}</div>
                    <div className={classes.stepName}>{intl.formatMessage({ id: `step.${name}` })}</div>
                  </div>
                )}
              </React.Fragment>
            ))}
          {/* {stepsPairs
            .filter((_, index) => index < 4)
            .map(([name, step]) => (
              <React.Fragment key={step.toString()}>
                {currentStep >= step ? (
                  <div
                    className={`${classes.stepperItem} ${classes.completed}`}
                    role='button'
                    aria-pressed='false'
                    tabIndex={0}
                    onClick={() => setStep(step)}
                  >
                    <div className={classes.stepCounter}>{step}</div>
                    <div className={classes.stepName}>{intl.formatMessage({ id: `step.${name}` })}</div>
                  </div>
                ) : (
                  <div className={`${classes.stepperItem}`}>
                    <div className={classes.stepCounter}>{step}</div>
                    <div className={classes.stepName}>{intl.formatMessage({ id: `step.${name}` })}</div>
                  </div>
                )}
              </React.Fragment>
            ))} */}
        </div>
      ) : null}
    </>
  );
};
Stepper.displayName = 'Stepper';

export default Stepper;
